
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { debugLogger } from './utils/debugLogger'
import { initializeSecurityMeasures } from './utils/security'

debugLogger.log('MAIN', '🚀 Application starting... Debug logging enabled');

// Initialize security measures
initializeSecurityMeasures();

createRoot(document.getElementById("root")!).render(<App />);
